export default __webpack_public_path__ + "images/39d1a478d14e4ba3d0d2660dfb8ef6bb.svg";